import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { AuthenticationService } from "app/auth/service";
import { UtilsService } from "../service/utils.service";
import { locale as italian } from "../../i18n/it";
import { ToastrService } from "ngx-toastr";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  /**
   * @param {Router} _router
   * @param {AuthenticationService} _authenticationService
   * @param _utilService
   */
  constructor(
    private _router: Router,
    private _authenticationService: AuthenticationService,
    private _utilService: UtilsService,
    private _toastService: ToastrService,
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err) => {
        this._utilService.hideLoading();

        if (err.status === 401 || err.status === 403) {
          this._authenticationService.logout();
          // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
          setTimeout(() => this._router.navigate(["/auth/login"]));
        }
        // throwError
        const errorMessage: string = err?.error?.message || err?.message || err?.statusText;

        if (err.status === 409 || err.status === 406) {
          const translationKey = errorMessage.toLowerCase().replace(/\s/gi, "_");
          if (italian.data.ERRORS[translationKey]) {
            this._toastService.error(italian.data.ERRORS[translationKey], italian.data.ALERT.ALERT_TITLE, {
              progressBar: true,
              timeOut: 300000,
            });
          }
        }

        return throwError(errorMessage);
      }),
    );
  }
}
